import axios from 'axios';
import { getAuthToken } from '../utils/auth';
import { handleError } from '../utils/errorHandler';

const apiClient = axios.create({
  // Must be REACT_APP_* — plain API_BASE_URL in .env is not available in the browser.
  baseURL: process.env.REACT_APP_API_ENDPOINT || 'https://apiqa.eventox.co/api',
  //baseURL : 'http://localhost:3006/api'
  // headers: {
  //   'Content-Type': 'application/json',
  // },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      // window.location.href = '/login'; 
    }
    handleError(error);
    return Promise.reject(error);
  }
);

export default apiClient;
